import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useOutboxCount } from '@/lib/offline';

export function OfflineBadge() {
  const queued = useOutboxCount();
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  if (online && queued === 0) return null;

  return (
    <Link
      to="/sync"
      className={`text-xs px-2 py-1 rounded-md font-medium ${
        online ? 'bg-amber-100 text-amber-800' : 'bg-rose-100 text-rose-800'
      } hover:opacity-80`}
      title={online ? 'Pending sync (click to inspect)' : 'Offline - changes will sync when you reconnect'}
    >
      {online ? `Syncing ${queued}` : `Offline${queued ? ` · ${queued} queued` : ''}`}
    </Link>
  );
}
